import { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { IMPERSONATION_KEY, readImpersonation, stopImpersonation } from "../api/impersonation";
import { socketClient } from "../api/socket";

export function ImpersonationBanner() {
  const { user } = useAuth();
  const [saved] = useState(readImpersonation);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [now, setNow] = useState(Date.now());
  const expiresAt = user.impersonation?.expires_at ?? saved?.expires_at;
  const active = !!user.impersonation || !!saved;
  const expired = !!expiresAt && now >= expiresAt * 1000;

  useEffect(() => {
    const onStorage = (event: StorageEvent) => {
      if (event.key === IMPERSONATION_KEY) {
        socketClient.close();
        window.location.reload();
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  useEffect(() => {
    if (!active) return;
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, [active]);

  if (!active) return null;
  return (
    <aside className="impersonation-banner" aria-label="Benutzerwechsel">
      <span role="status">
        {expired ? "Kundensitzung abgelaufen" : user.impersonation ? <>Eingeloggt als <strong>{user.username}</strong></> : "Kundensitzung wird geprüft – bei Problemen zum Admin zurückkehren."}
      </span>
      <button type="button" disabled={busy} onClick={async () => {
        setBusy(true);
        setError(null);
        try { await stopImpersonation(); }
        catch { setError("Rückkehr fehlgeschlagen. Bitte erneut versuchen."); setBusy(false); }
      }}>{busy ? "Wechsel läuft …" : "Zurück zum Admin"}</button>
      {error && <span role="alert">{error}</span>}
    </aside>
  );
}
